import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import {
  RetrieveUserDepositLimitRequest,
  TakeABreakRequest,
  UserPersistDepositLimitRequest,
  UserSelfExcludeRequest,
} from "../models/request";
import { UndoUserDepositLimitRequest } from "../models/request/undoUserDepositLimitRequest";
import {
  RetrieveUserDepositLimitResponse,
  UserPersistDepositLimitResponse,
} from "../models/response";

export const responsibleGamingApi = {
  retrieveDepositLimit: async (
    data: RetrieveUserDepositLimitRequest
  ): Promise<UnifiedResponse<RetrieveUserDepositLimitResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<RetrieveUserDepositLimitResponse>
    >("users/deposit_limit/retrieve", data);
    return response.data;
  },

  persistDepositLimit: async (
    data: UserPersistDepositLimitRequest
  ): Promise<UnifiedResponse<UserPersistDepositLimitResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<UserPersistDepositLimitResponse>
    >("users/deposit_limit/persist", data);
    return response.data;
  },

  undoDepositLimit: async (
    data: UndoUserDepositLimitRequest
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<
      UnifiedResponse<UndoUserDepositLimitRequest>
    >("users/deposit_limit/cancel", data);
    return response.data;
  },

  takeABreak: async (
    data: TakeABreakRequest
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "users/takeabreak/exclusion/persist",
      data
    );
    return response.data;
  },

  selfExclude: async (
    data: UserSelfExcludeRequest
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "users/account_selfexclude/update",
      data
    );
    return response.data;
  },
};
